export const URL_STYLES = {
  textDecoration: 'none',
  color: 'unset',
  cursor: 'unset',
} as const;
